import { Controller } from "@hotwired/stimulus"

// Show/hide toggle for the signup password field.
export default class extends Controller {
  static targets = ["input", "toggle"]

  toggle() {
    const hidden = this.inputTarget.type === "password"
    this.inputTarget.type = hidden ? "text" : "password"
    this.toggleTarget.textContent = hidden ? "Hide" : "Show"
  }
}
